import { globalAccounts } from './global-accounts';

/**
 * Get unique sub-categories for a given account type
 */
export function getSubCategoriesByType(type: 'asset' | 'liability' | 'equity' | 'income' | 'expense'): string[] {
    const subCategories = globalAccounts
        .filter(acc => acc.type === type && !acc.parentId) // Only parent accounts
        .map(acc => acc.subCategory)
        .filter((value, index, self) => value && self.indexOf(value) === index); // Unique values

    return subCategories as string[];
}

/**
 * Get all unique sub-categories grouped by type
 */
export const accountSubCategories = {
    asset: getSubCategoriesByType('asset'),
    liability: getSubCategoriesByType('liability'),
    equity: getSubCategoriesByType('equity'),
    income: getSubCategoriesByType('income'),
    expense: getSubCategoriesByType('expense'),
};

/**
 * Account type labels in Indonesian
 */
export const accountTypeLabels = {
    asset: 'Aset',
    liability: 'Liabilitas',
    equity: 'Ekuitas',
    income: 'Pendapatan',
    expense: 'Beban',
};

/**
 * Get category label in Indonesian
 */
export function getCategoryLabel(type: string): string {
    return accountTypeLabels[type as keyof typeof accountTypeLabels] || type;
}
